import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Edit from './edit';
import save from './save';
import './style.css';

registerBlockType('custom/slideshow-block', {
  title: __('Slideshow Block', 'custom'),
  icon: 'images-alt2',
  category: 'media',
  attributes: {
    height: {
      type: 'number',
      default: 400,
    },
  },
  supports: {
    align: ['wide', 'full'],
  },
  edit: Edit,
  save,
});
